// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_d-2";
export var blackBorderOnHover = "_d-7";
export var cell = "_d-6";
export var cellContainer = "_d-3";
export var checked = "_d-8";
export var disabled = "_d-5";
export var featuredIconCellContainer = "_d-9";
export var featuredIconTextContainer = "_d-b";
export var featuredIconWrapper = "_d-a";
export var noBorder = "_d-c";
export var orangeSelectedRow = "_r-3";
export var overflowableText = "_d-0";
export var overflowableTextContainer = "_d-1";
export var row = "_b-0";
export var rowCheckboxCell = "_d-4";
export var selectableTable = "_r-2";